// @wc-ignore-file

import { createFileRoute } from "@tanstack/react-router";

import { SupportPage } from "@/features/support/components/support-page";

/**
 * CR-189 D5: /support lives under _authenticated (an anonymous visitor gets the
 * login redirect). `?project=` is URL input: it only counts once
 * resolveSupportTarget finds it among the user's own eligible projects.
 */
export const Route = createFileRoute("/_authenticated/support")({
  validateSearch: (search): { project?: string } => ({
    project: typeof search.project === "string" ? search.project : undefined,
  }),
  component: SupportRoute,
});

function SupportRoute() {
  const { project } = Route.useSearch();
  return <SupportPage requestedProjectId={project} />;
}
